import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCardCoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={22} height={23} fill='none' {...props}>
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M1.833 16.138H11'
    />
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M3.868 12.875h5.097c1.632 0 2.035.403 2.035 2.017v3.767c0 1.614-.403 2.017-2.035 2.017H3.868c-1.631 0-2.035-.403-2.035-2.017v-3.767c0-1.614.404-2.017 2.035-2.017M20.167 14.25a6.41 6.41 0 0 1-6.417 6.417l.963-1.605M1.833 8.75A6.41 6.41 0 0 1 8.25 2.333l-.962 1.605M16.958 10.583a4.125 4.125 0 1 0 0-8.25 4.125 4.125 0 0 0 0 8.25'
    />
  </svg>
);
export default SvgCardCoin;
